<template>
  <picture>
    <source
      v-for="source in sources"
      :key="source.media"
      :media="`(max-width: ${source.maxWidth}px)`"
      :srcset="source.srcset"
    />
    <img :src="defaultSrc" :alt="alt" :style="imgStyle" @load="onLoad" />
  </picture>
</template>

<script>
export default {
  props: {
    defaultSrc: String,
    alt: String,
    sources: {
      type: Array,
      default: () => [],
    },
    imgStyle: Object,
  },
  methods: {
    onLoad() {
      this.$emit('loaded');
    },
  },
};
</script>
